import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';
import { renderPrice } from 'utils/helper/price';

import './campaign-payouts-variable-payments-budget.scss';

applyTranslations(require('./campaign-payouts-variable-payments-budget.i18n.json'));

type Props = {
  remainingBudget: number,
  totalBudget: number
};

const CampaignPayoutsVariablePaymentsBudget = ({
  remainingBudget,
  totalBudget
}: Props) => {
  const remainingTitle = __t(
    'campaign_payouts_variable_payments_budget.remaining_budget',
    { budget: renderPrice(remainingBudget) }
  );
  const totalTitle = __t(
    'campaign_payouts_variable_payments_budget.total_budget',
    { budget: renderPrice(totalBudget) }
  );

  return (
    <div className="campaign-payouts-variable-payments-budget">
      <div
        className="campaign-payouts-variable-payments-budget__remaining"
        title={remainingTitle}
      >
        {remainingTitle}
      </div>
      <div
        className="campaign-payouts-variable-payments-budget__total"
        title={totalTitle}
      >
        {totalTitle}
      </div>
    </div>
  );
};

export default CampaignPayoutsVariablePaymentsBudget;
